import React, {Component} from 'react';
import StampsDescription from "./stampsDescription";
import StampsItems from "./stampsItems";

export default class Stamps extends Component {
    render() {
        return (
            <section ref={this.props.refs.Stamps} id="stamps">
                <div className="container">
                    <div className="box-shadow-full">
                        <StampsDescription/>
                        <StampsItems/>
                    </div>
                </div>
            </section>
        );
    }
}